export default __webpack_public_path__ + "static/media/279.9e42d052.jpg";